import React from 'react'
import { EntradaSaidaManutencaoProps } from './types'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'

const SaidaDiaAnterior: React.FC<EntradaSaidaManutencaoProps> = ({
    categoria,
    saidaDiaAnterior,
    entradaDiaSeguinte,
    isLoading,
    toggle,
}) => {
    if (categoria === 5) return null

    return (
        <FormControlLabel
            control={<Checkbox />}
            label="Saida no dia anterior"
            disabled={entradaDiaSeguinte === 'S' || isLoading}
            checked={saidaDiaAnterior === 'S'}
            onChange={() => toggle('saida-dia-anterior')}
        />
    )
}

export default SaidaDiaAnterior
